import { Theme } from 'src/types/Theme';
import { PLICK_THEME } from './plick';

export const plickTheme: Theme & { colors: Theme['colors'] & { whatsapp: string; whatsAppDark: string } } = {
  colors: { ...(PLICK_THEME as Theme).colors, whatsapp: '#25D366', whatsAppDark: '#04AF00' },
};
